import React from "react";
import Amount from "../../ui-components/molecules/amount/amount";

export interface PaymentInvoiceLine {
  invoiceNumber: number;
  amountCents?: number;
}

interface PaymentSummaryProps {
  amountCents?: number;
  surchargeAmountCents?: number;
  invoices?: PaymentInvoiceLine[];
}

const invoiceSubtotalCents = (
  amountCents: number | undefined,
  invoices: PaymentInvoiceLine[] | undefined
): number => {
  if (invoices && invoices.length > 0) {
    return invoices.reduce((sum, line) => sum + (line.amountCents ?? 0), 0);
  }
  return amountCents ?? 0;
};

export const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  amountCents,
  surchargeAmountCents,
  invoices,
}) => {
  const invoiceCents = invoiceSubtotalCents(amountCents, invoices);
  const surchargeCents = surchargeAmountCents ?? 0;
  const paidCents = invoiceCents + surchargeCents;

  return (
    <div className="payment-receipt__breakdown">
      <div className="payment-receipt__breakdown-title">PAYMENT SUMMARY</div>
      <div className="payment-receipt__breakdown-row">
        <span>Invoice subtotal</span>
        <Amount amount={invoiceCents / 100} />
      </div>
      {surchargeCents > 0 && (
        <div className="payment-receipt__breakdown-row">
          <span>
            Surcharge
            <span className="payment-receipt__breakdown-note">Credit card transaction fee</span>
          </span>
          <Amount amount={surchargeCents / 100} />
        </div>
      )}
      <div className="payment-receipt__breakdown-row payment-receipt__breakdown-row--total">
        <span>Total paid</span>
        <Amount amount={paidCents / 100} />
      </div>
    </div>
  );
};

export const InvoicesPaid: React.FC<{ invoices?: PaymentInvoiceLine[] }> = ({ invoices }) => {
  if (!invoices?.length) return null;
  return (
    <div className="payment-receipt__breakdown">
      <div className="payment-receipt__breakdown-title">INVOICES PAID</div>
      <div className="payment-receipt__breakdown-row payment-receipt__breakdown-head">
        <span>Invoice number</span>
        <span>Amount paid</span>
      </div>
      {invoices.map((line) => (
        <div className="payment-receipt__breakdown-row" key={line.invoiceNumber}>
          <span>{line.invoiceNumber}</span>
          <Amount amount={(line.amountCents ?? 0) / 100} />
        </div>
      ))}
    </div>
  );
};
